'use client';

import Select, { SelectProps } from '@/components/Form/Select';
import { forwardRef } from 'react';

const PrescriptionSelect = forwardRef<HTMLDivElement, SelectProps>((props, ref) => {
  return (
    <Select
      ref={ref}
      sx={{
        '& .MuiSelect-select': {
          alignItems: 'center!important',
          justifyContent: 'center!important',
        },
        '& .MuiSelect-icon': {
          fontSize: '16px',
          color: '#808080',
        },
      }}
      menuMarginTop="-1px"
      menuSx={{
        '& .MuiMenuItem-root': {
          justifyContent: 'center',
        },
      }}
      {...props}
    />
  );
});

PrescriptionSelect.displayName = 'PrescriptionSelect';

export default PrescriptionSelect;
